import React from 'react'
import { content } from '../gift-texts/gift-texts'
import { strapiContent } from '../gift-strapi-content/gift-texts'
import GiftContext from '../../context/context'
import { REFERRAL_MODE, PROMO_MODE } from '../../shared/modes'
import { CONTENT_DONE, CONTENT_SIGNUP, CONTENT_LOGIN } from '../../shared/contentStates'

class GiftContent extends React.Component {
  static contextType = GiftContext
  state = {
    success: false,
  }

  getPromoContent(code) {
    return content.promo.welcome(this.context.formData.lang, code)
  }

  getReferralContent() {
    return content.referral.welcome()
  }

  getReferralDone() {
    return (
      <div key="done">
        {content.referral.done()}
      </div>
    )
  }

  getPromoDone() {
    return content.promo.done(this.context.formData.lang, this.context.formData.code)
  }

  getPromoLogin() {
    return content.promo.login(this.context.formData.lang, this.context.formData.code)
  }

  getReferralLogin() {
    return content.referral.login()
  }

  getDoneContent(mode) {
    if (mode === REFERRAL_MODE) return this.getReferralDone()
    if (mode === PROMO_MODE) return this.getPromoDone()
  }

  getSignupContent(mode, code) {
    if (mode === REFERRAL_MODE) return this.getReferralContent()
    if (mode === PROMO_MODE) return this.getPromoContent(code)
    return null
  }

  getLoginContent(mode) {
    if (mode === REFERRAL_MODE) return this.getReferralLogin()
    if (mode === PROMO_MODE) return this.getPromoLogin()
  }

  getSignupStrapiContent(content){
    return strapiContent.welcome(content)
  }
  getLoginStrapiContent(content){
    return strapiContent.login(content)
  }
  getDoneStrapiContent(content){
    return strapiContent.done(content)
  }

  getContent(contentState, mode, code) {
    return contentState === CONTENT_DONE
      ? this.getDoneContent(mode)
      : contentState === CONTENT_SIGNUP
      ? this.getSignupContent(mode, code)
      : contentState === CONTENT_LOGIN
      ? this.getLoginContent(mode)
      : null
  }

  getStrapiContent(contentStrapi, contentState, mode, code) {
    return contentState === CONTENT_DONE
      ? this.getDoneStrapiContent(contentStrapi, mode)
      : contentState === CONTENT_SIGNUP
      ? this.getSignupStrapiContent(contentStrapi)
      : contentState === CONTENT_LOGIN
      ? this.getLoginStrapiContent(contentStrapi, mode)
      : null
  }

  render() {
    const { contentState, contentStrapi } = this.props
    const { mode, code } = this.context.formData
    if(contentStrapi) {
      return this.getStrapiContent(contentStrapi, contentState, mode, code)
    }

    return this.getContent(contentState, mode, code)
  }
}

export { GiftContent }
